import React,{Component} from 'react';
import {connect} from "react-redux";
import "./style.less";
import {NavBar,Modal,Toast,Button} from "antd-mobile";
import {TwoCode} from "../../../service/memberService";

@connect(
    state => ({userInfo: state.userInfo}),
)
export default class TwoDimensional extends Component{
    constructor(props) {
        super(props);
        console.log(props)
        this.state = {
           image:'',
        };
    }

    componentWillMount(){
       this.getCode();
    }
    getCode = () =>{
        let params = {
            token: this.props.userInfo.token,
        };
        TwoCode(params)
            .then((res) => {
                console.log(res)
                if (res.data.code === '0000') {
                    this.setState({
                        image:res.data.data.qrCodeUrl
                    })
                 }
                 else if (res.data.code === '1401') {
                    document.location = `js://toLogin?token=${this.props.userInfo.token}`;
                 }
                 else {
                     Toast.info(res.data.msg);
                 }
            }).catch(function (error) {
        });
    }
   
    render(){
        return(
            <div className="twoDimensional">
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconmorenfanhui" onClick={() => this.props.history.goBack()}/>}
                >二维码</NavBar>
                <div className="content">
                    <div className="bgwhite"><span>专属二维码</span></div>
                    <p></p>
                    <div className="pay"><i className="icon iconfont iconshuomingtishi"/>用户扫描后将归属为您名下的顾客</div>
                    <div className="img"><img src={this.state.image}/></div>
            
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/Member/TwoDimensional/index.js